<template>
    <div class="floor buy">
		<!-- 楼层标题 -->
		<div class="floor_title">
		    <div class="floor_title_content">
		        <span class="floor_title_border"></span>
		        <span class="floor_title_content_index">{{ floorConfig.index || "求购" }}</span>
		        <span class="floor_title_content_text">{{ floorConfig.title || "" }}</span>
		    </div>
		    <div class="other-title" >
		        <router-link to="/buy">查看更多<i class="iconfont iconarrow-right"></i></router-link>
		    </div>
		</div>
        <!-- 楼层内容区 -->
		<div class="floor-content">
			<div class="buy-list" v-if="buyList.length">
				<template >
					<el-table :data="buyList" style="width: 100%">
						<el-table-column prop="area.name" label="求购地区" width="180">
							<template slot-scope="scope">
								 {{scope.row.area ? scope.row.area.name :'全国' }}
							 </template>
						</el-table-column>
						<el-table-column prop="contacts" label="求购人" width="180">
							<template slot-scope="scope">
								<span>
									{{contacts(scope.row)}}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="求购产品"></el-table-column>
						<el-table-column prop="price" label="价格">
							<template slot-scope="scope">
								<span v-if="scope.row.price>0">
									{{scope.row.price}}
								</span>
								<span v-else>
									面议
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" label="发布时间"></el-table-column>
						<el-table-column prop="describe" label="需求描述"></el-table-column>
						<!-- :filters="[{ text: '家', value: '家' }, { text: '公司', value: '公司' }]" -->
						
						<el-table-column
						     prop="tag"
						     label="操作"
						     width="100"
						     filter-placement="bottom-end">
						     <template slot-scope="scope">
								   <el-button type="primary" round @click="$router.pushToTab({ path: '/buy-detail-' + scope.row.id })">查看</el-button>
						    </template>
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { buyList } from "@/api/cms/buy"
	
    export default {
        name: "buy",
        components: {
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                buyList: []
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getbuyList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
			contacts(row){
				let str  = (row.tel || row.phone || row.email || row.site.telephone || row.site.mobile || row.site.email || '')
				// console.log(str,row)
				if(str){
					return str.substr(0,3)+"****"+str.substr(7);
				}
				return '暂无';
			},
            tobuy(item) {
                if (item) {
                    this.$router.pushToTab(`/list?buy_id=${item.buy_id}`)
                }
            },
            getbuyList() {
                // const sku_ids = this.floorConfig.rightCargos
                //     .map(item => {
                //         return item.sku_id
                //     })
                //     .toString()
				
                buyList({
					page_size:8
				})
                    .then(res => {
                        this.buyList = res.data.list
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
		width: 1210px;
		&_title {
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    padding-right: 20px;
		    &_border {
		        display: inline-block;
		        width: 5px;
		        height: 28px;
		        background-color: $base-color;
		        margin-right: 12px;
		        vertical-align: top;
		    }
		
		    &_content {
		        font-size: 20px;
		        padding-top: 10px;
		        padding-bottom: 10px;
		        height: 48px;
		        line-height: 28px;
		        // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
		        box-sizing: border-box;
		
		        &_index {
		            display: inline-block;
		            color: $ns-text-color-black;
		            padding-right: 8px;
		            font-weight: 600;
		        }
		
		        &_text {
		            font-weight: 600;
		            display: inline-block;
		            color: $base-color;
		        }
		    }
			.other-title {
			    a {
			        color: #838383;
			
			        i {
			            font-size: 14px;
			        }
			
			        &:hover {
			            color: $base-color;
			        }
			    }
			}
		}
        .floor-content {
            display: flex;
            flex-wrap: wrap;
			.buy-list{
				width: 100%;
				background-color: #fff;
			}
			.empty {
				margin-top: 45px;
			}
        }
    }
</style>
